import { render, staticRenderFns } from "./MultiLineText.vue?vue&type=template&id=e3fc78ce&scoped=true"
import script from "./MultiLineText.vue?vue&type=script&lang=js"
export * from "./MultiLineText.vue?vue&type=script&lang=js"
import style0 from "./MultiLineText.vue?vue&type=style&index=0&id=e3fc78ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc78ce",
  null
  
)

export default component.exports